import React, { PropsWithChildren } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'

const Container = styled.div`
  padding: ${rem(8)};

    &.meta-container ul > li {
      &::before {
        content: "•";
      }
    }
`

type Props = PropsWithChildren<{}>

export default function LesaPurchaseSummaryMetaContainer(props: Props) {
  const { children } = props

  return (
    <Container className="meta-container">
      {children}
    </Container>
  )
}
